import { get } from "lodash"
import { numberFormatter } from "helpers/formatters/numbers"
import { sanitizePositionSet } from "../helpers"
import { generateQueryKey } from "connected-components/dashboard/helpers/query-key"

const QUERY = `query MultiDateContentSetExposureQuery($modelId: String!, $contentSetId: String!, $positionSet: PositionSetInput!, $base: [PositionSetInput], $from: Date!, $to: Date!) {
  model(id: $modelId) {
    simulation(positionSet: $positionSet, base: $base, from: $from, to: $to) {
      exposure(contentSetId: $contentSetId) {
        date
        factors {
          id
          name
          category
          net
        }
      }
    }
  }
}`

export function createContentSetExposureMultiDateQuery(modelId, contentSetId, positionSet, base, from, to) {
  return {
    key: generateQueryKey("content-set.exposure.multiDate", { contentSetId, modelId, positionSet, base, from, to }),
    query: QUERY,
    variables: {
      contentSetId,
      modelId,
      positionSet: sanitizePositionSet(positionSet),
      base,
      from,
      to,
    },
    select: (graphqlResult) => {
      const exposure = get(graphqlResult, "data.model.simulation.exposure", [])
      return {
        values: {
          formatter: numberFormatter,
          dates: exposure.map(({ date, ...dateData }) => {
            const factors = dateData.factors.reduce((acc, { id, net }) => {
              acc[id] = net
              return acc
            }, {})

            return {
              date,
              ...factors,
            }
          }),
        },
      }
    },
  }
}
